export const columnsInvoiceAdmin = (onClickEmployeeList) => [
  {
    accessorKey: 'id',
    header: 'Id', //uses the default width from defaultColumn prop
    // hishem avelacnem
    size: 30,
    Cell: ({ row }) => <p className="whitespace-nowrap">#{row?.original?.invoice_number}</p>,
  },
  {
    accessorKey: 'employees',
    header: 'Employee', //uses the default width from defaultColumn prop
    // hishem avelacnem
    size: 140,
    Cell: ({ row }) => (
      <p
        className="whitespace-nowrap cursor-pointer"
        onClick={() =>
          onClickEmployeeList({
            showStatus: true,
            array: row?.original?.['employees']?.map(elem => {
              return {
                name: elem
              };
            }),
          })
        }>
        {row?.original?.['employees']?.map(
          (e, index, array) => `${e + `${index !== array?.length - 1 ? `,` : ' '} `}`,
        )}
      </p>
    ),
  },
  {
    accessorKey: 'client',
    header: 'Clients', //uses the default width from defaultColumn prop
    // hishem avelacnem
    // size: 40,
    Cell: ({ row }) => <p className="whitespace-nowrap">{row?.original?.client ?? ''}</p>,
  },
  {
    accessorKey: 'date',
    header: 'Date Range', //uses the default width from defaultColumn prop
    // hishem avelacnem
    // size: 40,
    Cell: ({ row }) => <p className="whitespace-nowrap">{row?.original?.date ?? ''}</p>,
  },
  {
    accessorKey: 'price',
    header: 'Amount', //uses the default width from defaultColumn prop
    // hishem avelacnem
    size: 60,
    Cell: ({ row }) => <p className="whitespace-nowrap">{row?.original?.price ?? ''}</p>,
  },
  {
    accessorKey: 'type',
    header: 'Type', //uses the default width from defaultColumn prop
    // hishem avelacnem
    size: 50,
    Cell: ({ row }) => <p className="whitespace-nowrap">{row?.original?.type ?? ''}</p>,
  },
];
